import { story } from "@/mocks/manga";

export default function Story() {
  return (
    <section id="story" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-14">
          <div className="relative">
            <div className="absolute -left-3 -top-3 h-24 w-24 rounded-full bg-secondary-100" aria-hidden="true"></div>
            <div className="relative overflow-hidden rounded-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20cheerful%20girl%20chasing%20a%20flustered%20cool%20boy%20across%20a%20sunny%20school%20courtyard%2C%20cherry%20petals%20floating%2C%20warm%20coral%20and%20peach%20palette%2C%20dynamic%20clean%20manga%20style%2C%20high%20detail&width=1200&height=760&seq=story-01&orientation=landscape"
                alt="恋爱辅助器漫画故事场景：苏念安追逐陆之遥的校园画面"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-4 -right-3 rounded-full bg-accent-500 px-5 py-2 font-display text-sm font-bold text-white shadow-lg">
              # 双向奔赴
            </div>
          </div>

          <div>
            <p className="mb-3 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-500">
              <span className="h-px w-8 bg-primary-400" aria-hidden="true"></span>
              故事简介
            </p>
            <h2 className="font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
              {story.title}
            </h2>
            <p className="mt-4 text-base font-medium leading-relaxed text-primary-700">
              {story.highlight}
            </p>
            {story.paragraphs.map((p) => (
              <p key={p.slice(0, 8)} className="mt-4 text-sm leading-7 text-foreground-700">
                {p}
              </p>
            ))}

            <div className="mt-6 flex flex-wrap gap-2">
              {story.tags.map((t) => (
                <span
                  key={t}
                  className="rounded-full bg-secondary-100 px-4 py-1.5 text-xs font-medium text-secondary-900"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}